import {
  regex
} from 'vuelidate/lib/validators/common';

export default regex('taxIdNumber', /^(?!.*(\d)\1{8}).*$/);